import { GraphQLContentMapper } from './GraphQLContentMapper'
import { pageBlockMapper } from './blocks/PageBlockMapper'
import { quizBlockMapper } from './blocks/QuizBlockMapper'

export const graphqlContentMapper = new GraphQLContentMapper([quizBlockMapper, pageBlockMapper])
